import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { Route, Routes, useNavigate, useSearchParams } from "react-router-dom";
import { CardPriceAtMill } from "../component/CardPriceAtMill";
import { Header } from "../component/Header";
import { buildMillPrices } from "../model/MillPriceOnMap";
import { PriceModel } from "../model/PriceModel";
import { PagePriceMillAccepted } from "./PagePriceMillAccepted";

export function MillPrices() {

    const [prices, setPrices] = useState<PriceModel[]>([])

    // const [loading, setLoading] = useState(false)

    // const [error, setError] = useState<string | undefined>(undefined)

    const [param] = useSearchParams()
    const target = useRef<string>(param.get('mills'))

    const priceSelected = useRef<number | undefined>(undefined)

    const navigate = useNavigate();

    function fetchAllPrices() {
        axios.get(`${process.env.REACT_APP_BASE_URL_PUBLIC}/mapTilingService/prices`, {
            withCredentials: false,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        }).then((data: any) => {
            const prices = buildMillPrices(data.data?.prices)
            if (prices.length) {
                const ps = prices.map(p => PriceModel.buildFromFeature(p, { coordinates: p.coordinates }))
                filterPrices(ps)
            } else {
                // setError('tidak ada harga yang tersedia')
            }
        }).catch(e => {
            if (e?.message) {
                // setError(e?.message)
            } else {
                // setError('An error occured')
            }
        })
            .finally(() => {
                // setLoading(false)
            })
    }

    function filterPrices(pricesParam: PriceModel[]) {
        let priceFiltered: PriceModel[] = pricesParam
        try {
            if (target.current) {
                const ids = JSON.parse(target.current) as [];
                priceFiltered = pricesParam.filter(p => ids.find(i => i === p.millId))
            }
        } catch (e) {
            console.error(e)
        }
        setPrices(priceFiltered)
    }

    useEffect(() => {
        fetchAllPrices()
        // eslint-disable-next-line
    }, [])

    return (
        <div className="pempem-flex-col-center">
            <Header />
            <div style={{ display: "flex", flexDirection: "column", gap: 24, padding: 24, alignItems: 'center', maxWidth: '500px' }}>
                {prices.map((price, idx) => (
                    <div
                        className="card-price-at-mill-responsive">
                        <CardPriceAtMill
                            key={price.id ?? idx}
                            price={price}
                            style={{ width: '100%' }}
                            onClick={() => { navigate('list_price_mill_accepted') }}
                        />
                    </div>
                ))}
            </div>
            <Routes>
                <Route path="list_price_mill_accepted" element={
                    <PagePriceMillAccepted page="list_price_mill_accepted" millPriceAccepted={priceSelected.current} />
                } />
            </Routes>
        </div>
    );
}

export default MillPrices;